
import { Link, useLocation } from "react-router-dom"
import Wrapper from "./wrappers"
import { useEffect, useLayoutEffect, useRef, useState, createContext, useContext } from "react"
import { debounce, vh } from "../utils/global"
import { useAuth } from "../hooks/useAuth"
import { useAppContext } from "../contexts/app"
import { useSessionTimer } from "../hooks/useSessionTimer"
import { AspectImage } from "./assets"

const CategoryNavContext = createContext();

export const useCategoryNav = () => {
	const context = useContext(CategoryNavContext);
	if (!context) {
		return { categoryNavOpen: false, setCategoryNavOpen: () => {} };
	}
	return context;
}

export const LogoutLink = ({ base, currentUser, logout }) => {
	const { timeRemaining } = useSessionTimer();

	return currentUser && <Link to="/" onClick={logout} title={`Logout of ${ currentUser.userinfo?.name }`}>
		<span className="tw-flex tw-items-center tw-w-full tw-space-x-5px">
		<span>Logout</span>
			{ base ? <></> : <span className="tw-text-[.7em] tw-flex tw-flex-col tw-leading-none tw-items-center"><b className="">{ timeRemaining }</b> <span className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-[0.4375rem]">minutes <span>remaining</span></span></span> }
		</span>
	</Link>
}

export const Header = ({tout, ...props}) => {
	const headerRef = useRef(null);
	const { timeRemaining } = useSessionTimer();
	const { currentUser, logout } = useAuth();

	const setHeaderHeight = (el) => {
		const header = el || document.querySelector("#header");
		document.documentElement.style.setProperty("--header-height", `${(header)?.offsetHeight || 0}px`);
	}

	useEffect(() => {
		if (headerRef?.current) {
			setTimeout(() => {
				setHeaderHeight(headerRef?.current)
			}, 0);
			if (window) window.addEventListener("resize", debounce(setHeaderHeight(headerRef?.current), 30));
		}
	}, [headerRef]);

	return <>
		{ tout && currentUser && <>
			{ Number(timeRemaining) > 1 && <>
				<div className=" tw-bg-accent-dark tw-justify-center tw-text-white tw-text-4 tw-py-10px tw-px-20px tw-text-center tw-fixed tw-w-full tw-top-0 tw-right-0 tw-left-0 tw-z-10">
					<p>
						{ tout }
					</p>
					<div className="tw-flex tw-w-full tw-justify-center tw-uppercase tw-font-quaternary tw-font-quaternary-black">
						<LogoutLink base currentUser={ currentUser } logout={ logout } />
					</div>
				</div>
			</> }
		</> }
		<header ref={ headerRef } id="header" className="tw-bg-black tw-border-b tw-border-b-white/10 tw-text-white tw-select-none tw-shadow-sm">
			<Wrapper className="tw-py-20px tw-space-x-40d [&>a]:tw-w-full [&_a]:tw-inline-flex [&_a]:tw-text-inherit [&_a]:tw-items-center [&_a]:tw-justify-center [&_a]:tw-text-white [&_a]:tw-transition-all [&_a]:tw-duration-200 hover:[&_a]:tw-text-primary tw-leading-[.9] tw-font-quaternary tw-font-quaternary-black tw-tracking-tight tw-uppercase" tag="nav">
				<div className="tw-flex tw-gap-40d">
					<div className="[&_a]:tw-inline-flex tw-max-w-70px tw-flex-shrink-0">
						<Link to="/">
							<AspectImage src={`/images/rvmp-logo-bordered.svg`} alt="RVMP Logo" className="tw-w-full" aspect="1/1" />
						</Link>
					</div>
					<ul className="tw-flex-grow tw-flex [&>li]:tw-inline-flex tw-text-dynamic tw-gap-10d md:tw-gap-40d" style={{ '--min-font-size': 10, '--max-font-size': 20 }}>
						<li>
							<Link to="/dashboard/inventory">
								Inventory Tracker
							</Link>
						</li>
						<li>
							<Link to="/dashboard/weight-dims">
								Size &amp; Weight
							</Link>
						</li>
						{/* <li>
							<Link to="/dashboard/order-labels">
								Order Labels
							</Link>
						</li> */}
						<li className="tw-ml-auto">
							<span className="tw-flex">
								{ currentUser ? <LogoutLink currentUser={ currentUser } logout={ logout } /> : <Link to="/login" className="tw-text-inherit">Login</Link> }
							</span>
						</li>
					</ul>
				</div>
			</Wrapper>
		</header>
	</>
}


export const HeaderFS = ({tout, menuOpen, setMenuOpen, categoryNavOpen, ...props}) => {
	const { currentUser, logout } = useAuth();

	return <>
		<div id="qc-header" className="tw-w-full tw-px-20px tw-flex tw-justify-start tw-py-20px tw-shadow-drop-b-lg">
			<div className="tw-flex tw-flex-col md2:tw-flex-row">
				<div className="tw-w-full tw-max-w-300d-alt md2:tw-pr-30px md2:tw-pl-40px tw-pb-1 md2:tw-pb-0">
					<AspectImage src={`/images/flex-security.svg`} aspect="514/74" className="tw-w-full tw-max-w-300d" />
				</div>
				<div className="tw-flex-grow tw-text-dynamic-up tw-leading-none tw-flex tw-items-center tw-tracking-[.1em] tw-uppercase tw-font-quaternary tw-font-quaternary-thin tw-text-lg" style={{"--min-font-size": 30, "--max-font-size": 40}}>
					<span className="tw-inline-block tw-leading-none">
						PDI + Quality Control
					</span>
				</div>
			</div>
			<div className="tw-ml-auto tw-flex tw-flex-col tw-items-end">
				<span className="tw-flex tw-tracking-[.1em] tw-uppercase tw-font-quaternary tw-font-quaternary-thin">
					{ currentUser ? <LogoutLink currentUser={ currentUser } logout={ logout } /> : <Link to="/login" className="tw-text-inherit">Login</Link> }
				</span>
				<button
					onClick={() => setMenuOpen(!menuOpen)}
					className="md2:tw-hidden tw-w-30px tw-h-30px tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-[6px] tw-cursor-pointer tw-bg-transparent tw-border-none tw-p-0 tw-mt-auto tw-self-end"
					aria-label="Toggle menu"
				>
					<span className={`tw-w-full tw-h-[2px] tw-bg-current tw-transition-all tw-duration-300 tw-origin-center ${menuOpen ? 'tw-rotate-45 tw-translate-y-[8px]' : ''}`}></span>
					<span className={`tw-w-full tw-h-[2px] tw-bg-current tw-transition-all tw-duration-300 ${menuOpen ? 'tw-opacity-0' : 'tw-opacity-100'}`}></span>
					<span className={`tw-w-full tw-h-[2px] tw-bg-current tw-transition-all tw-duration-300 tw-origin-center ${menuOpen ? '-tw-rotate-45 -tw-translate-y-[8px]' : ''}`}></span>
				</button>
			</div>
		</div>
	</>
}


export const Base = props => {
	const { currentView, setCurrentView, setIsExternal, isExternal, setCurrentTime } = useAppContext();
	const { currentUser } = useAuth();
	const { timeRemaining, showWarning } = useSessionTimer();
	const [menuOpen, setMenuOpen] = useState(window.innerWidth >= 1120);
	const [showScrollTop, setShowScrollTop] = useState(false);
	const [categoryNavOpen, setCategoryNavOpen] = useState(false);

	const warningMessage = showWarning ? `You must login again within the next ${timeRemaining} minutes` : null;

	useLayoutEffect(() => {
		setCurrentTime(new Date().toISOString());
		vh();

		const handleResize = () => {
			if (window.innerWidth >= 1120) {
				setMenuOpen(true);
			} else {
				setMenuOpen(false);
			}
		};

		const handleScroll = () => {
			setShowScrollTop(window.scrollY > 300);
		};

		window.addEventListener('resize', handleResize);
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('resize', handleResize);
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};


	const location = useLocation();
	useEffect(() => {
		setCurrentView( location.pathname.includes("/pdf") || location.pathname.includes("/tracker") || location.pathname.includes("/fs/map")  ? "none" : location.pathname.includes("/fs") ? "fs" : "rvmp");
	  }, [location]);


	  useEffect(() => {
		if (currentUser ) setIsExternal( currentUser?.userinfo?.email?.includes("external.") );
	  }, [currentUser]);


	return <>
		{ currentView === "none" ? <>
			{ props.children }
			<style>
				{`
					:root, body, html, #root {
						background-color: #FFF !important;
						color: #000 !important;
					}

					:root, body, html, #root {
						height: 100vh;
						min-height: 100vh;
						overflow: hidden;
						width: 100vw;
					}

					#root {
						display: flex;
						flex-direction: column;
						overflow: hidden;
					}

					body {
						margin: 0;
					}

					iframe {
						width: 100vw;
						flex-grow: 1;
						border: none;
						overflow: auto;
						min-width: 100vw;
					}

				`}
			</style>
		</> : currentView === "rvmp" ? <>
			<div className="tw-flex tw-flex-col tw-min-h-screen tw-w-full tw-overflow-x-clip">
				<Header tout={ warningMessage }  />
				<Wrapper className="tw-py-40px tw-flex-grow" tag="main">
					{ props.children }
				</Wrapper>
			</div>
		</> : <>
			<CategoryNavContext.Provider value={{ categoryNavOpen, setCategoryNavOpen }}>
				<div className="tw-min-h-[100svh] tw-bg-secondary tw-flex-grow tw-font-quaternary tw-font-quaternary-thin tw-tracking-wide tw-flex tw-flex-col tw-w-full tw-relative">
					<HeaderFS tout={ warningMessage } menuOpen={menuOpen} setMenuOpen={setMenuOpen} categoryNavOpen={categoryNavOpen} />
					<div className="tw-flex tw-flex-col md2:tw-flex-row tw-w-full tw-flex-grow tw-border-t-1px tw-border-t-white/5 tw-z-2">
					<div id="fs-menu" className={`tw-bg-[#292927] tw-min-w-300d-alt tw-flex-shrink-0 tw-border-r-1px tw-border-r-white/5 tw-shadow-drop-r-lg tw-bg- tw-flex tw-flex-row tw-transition-all tw-duration-300 md2:tw-sticky md2:tw-top-0 tw-overflow-hidden ${menuOpen ? 'tw-max-h-screen tw-opacity-100' : 'tw-max-h-0 tw-opacity-0'}`}>
						<div className="tw-bg-secondary tw-w-40px tw-flex-grow tw-hidden md2:tw-flex tw-flex-col">
							<ul className="tw-flex-grow tw-pt-20px  tw-sticky tw-mt-20px tw-mb-auto tw-top-30px tw-justify-between tw-flex tw-flex-col tw-z-2  -tw-mr-10px tw-pr-5px tw-max-h-[25vh]">
								<li className="tw-flex tw-items-center tw-justify-center tw-bg-[#292927] tw-py-20px">
									<AspectImage className="tw-w-20px tw-bg-white tw-rounded-3px tw-overflow-hidden" />
								</li>
								<li className="tw-flex tw-items-center tw-justify-center  tw-py-20px">
									<AspectImage className="tw-w-20px tw-bg-white tw-rounded-3px tw-overflow-hidden" />
								</li>
								<li className="tw-flex tw-items-center tw-justify-center  tw-py-20px">
									<AspectImage className="tw-w-20px tw-bg-white tw-rounded-3px tw-overflow-hidden" />
								</li>
							</ul>
						</div>
						<ul className="tw-w-full md2:tw-w-[calc(100%-2.5rem)] tw-sticky tw-mt-20px tw-mb-20px md2:tw-mb-auto tw-top-30px tw-flex tw-flex-col tw-uppercase [&_a]:tw-flex [&_li]:tw-flex [&_a]:tw-flex-grow [&_li]:tw-flex-grow tw-tracking-widest tw-font-quaternary tw-font-quaternary-normal">
							{ isExternal !== true && <>
								<li>
									<Link to="/fs">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="fa-solid fa-table-columns"></i> Dashboard
										</span>
									</Link>
								</li>
								<li>
									<Link to="/fs/qc">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="fas fa-eye"></i> QC
										</span>
									</Link>
								</li>
							</> }
							<li>
								<Link to="/fs/flock-create/v5" title="Create Flock Units">
									<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
										<i className="tw-w-[1em] tw-inline-flex tw-justify-center tw-items-center tw-aspect-square tw-shrink-0 tw-rounded-full tw-bg-white tw-overflow-hidden">
											<AspectImage src="/images/flock-logo.svg" aspect="1/1" className="tw-w-9/12 tw-invert" />
										</i> Create
									</span>
								</Link>
							</li>
							<li>
								<Link to="/fs/flock-inventory" title="Edit Flock Units">
									<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
										<i className="tw-w-[1em] tw-inline-flex tw-justify-center tw-items-center tw-aspect-square tw-shrink-0 tw-rounded-full tw-bg-white tw-overflow-hidden">
											<AspectImage src="/images/flock-logo.svg" aspect="1/1" className="tw-w-9/12 tw-invert" />
										</i>  Edit/View
									</span>
								</Link>
							</li>
							{ isExternal !== true && <>
								<li>
									<Link to="/fs/inventory">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="fa-solid fa-sitemap"></i> Units
										</span>
									</Link>
								</li>
								<li>
									<Link to="/fs/customers">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="tw-justify-center tw-items-center tw-aspect-square tw-shrink-0"><svg
												xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
												stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
												class="lucide lucide-users-round tw-inline tw-pb-[.2em]" aria-hidden="true">
												<path d="M18 21a8 8 0 0 0-16 0"></path>
												<circle cx="10" cy="8" r="5"></circle>
												<path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"></path>
											</svg></i>
											Customers
										</span>
									</Link>
								</li>
								<li>
									<Link to="/fs/quotes">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="fa-solid fa-file-invoice-dollar"></i> Quotes
										</span>
									</Link>
								</li>
								<li>
									<Link to="https://ops.flexsecurity.com/fs/unit-management" target="_blank">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="fa-solid fa-sitemap"></i> Unit Management
										</span>
									</Link>
								</li>
								<li>
									<Link to="/fs/map" target="_blank">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="fa-solid fa-sitemap"></i> Map View
										</span>
									</Link>
								</li>
								{/* <li>
									<Link to="https://ops.flexsecurity.com/fs/vrm-validator" target="_blank">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="fa-solid fa-check-double"></i> VRM Validator
										</span>
									</Link>
								</li> */}
								{/* <li>
									<Link to="/fs/gcloud-images">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
											<i className="fa-solid fa-cloud"></i> Cloud Images
										</span>
									</Link>
								</li> */}
							</> }
							<li>
								<Link to="/fs/completed-units">
									<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none">
										<i className="fa-solid fa-check-circle"></i> Completed Units
									</span>
								</Link>
							</li>
							{ isExternal !== true && <>
								<li>
									<Link reloadDocument to="/fs/unit" className="tw-px-20px tw-py-5px">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none tw-border tw-border-1px tw-w-full tw-flex tw-justify-center tw-items-center tw-tracking-wider tw-font-quaternary tw-font-quaternary-bold">
											Add Unit
										</span>
									</Link>
								</li>
								<li>
									<Link reloadDocument to="/fs/customer" className="tw-px-20px tw-py-5px">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none tw-border tw-border-1px tw-w-full tw-flex tw-justify-center tw-items-center tw-tracking-wider tw-font-quaternary tw-font-quaternary-bold">
											Create Customer
										</span>
									</Link>
								</li>
								<li>
									<Link reloadDocument to="/fs/quote" className="tw-px-20px tw-py-5px">
										<span className="tw-px-20px tw-py-5px tw-flex-grow tw-pointer-events-none tw-border tw-border-1px tw-w-full tw-flex tw-justify-center tw-items-center tw-tracking-wider tw-font-quaternary tw-font-quaternary-bold">
											Create Quote
										</span>
									</Link>
								</li>
							</> }
						</ul>
					</div>
					<div className="tw-flex-grow tw-pt-20px tw-px-10px md2:tw-px-20px">
						<div className="tw-mx-auto tw-w-full tw-max-w-760px">

							{ props.children }
						</div>
					</div>
					<div className="md2:tw-basis-300d-alt tw-hidden md2:tw-flex"></div>
				</div>
				<button
					onClick={scrollToTop}
					className={`tw-fixed tw-bottom-150px md2:tw-bottom-80px tw-right-20px tw-w-50px tw-h-50px tw-rounded-full tw-bg-flex-security tw-text-white tw-flex tw-items-center tw-justify-center tw-shadow-lg tw-cursor-pointer tw-border-none tw-transition-all tw-duration-300 tw-z-50 ${showScrollTop && !categoryNavOpen ? 'tw-opacity-100 tw-translate-y-0' : 'tw-opacity-0 tw-translate-y-20px tw-pointer-events-none'}`}
					aria-label="Scroll to top"
				>
					<i className="fas fa-arrow-up"></i>
				</button>
			</div>
			</CategoryNavContext.Provider>
		</> }
	</>
}

export default Base;
